import React from 'react';
import IntlMessage from '../components/IntlMessage';
import {
  BankOutlined,
  CalendarOutlined,
  CarOutlined,
  CreditCardOutlined,
  CustomerServiceOutlined,
  EnvironmentOutlined,
  FileOutlined,
  HistoryOutlined,
  HomeOutlined,
  LockOutlined,
  MessageOutlined,
  NodeIndexOutlined,
  SettingOutlined,
  TableOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';

const menu = [
  {
    key: '/app/home',
    label: <IntlMessage id="global.home" />,
    icon: <HomeOutlined />,
    permission: null,
    children: null,
  },
  {
    key: '/app/orders-route',
    label: <IntlMessage id="global.orders" />,
    icon: <EnvironmentOutlined />,
    permission: null,
    children: [
      {
        key: '/app/orders',
        label: <IntlMessage id="global.orders" />,
        icon: <CalendarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/booking_statistic',
        label: <IntlMessage id="global.booking_statistic" />,
        icon: <CalendarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/trips',
        label: <IntlMessage id="global.trips" />,
        icon: <LockOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: '/app/routes-route',
    label: <IntlMessage id="global.routes" />,
    icon: <NodeIndexOutlined />,
    permission: null,
    children: [
      {
        key: '/app/routes',
        label: <IntlMessage id="global.routes" />,
        icon: <NodeIndexOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/rates',
        label: <IntlMessage id="global.rates" />,
        icon: <CalendarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/vehicles',
        label: <IntlMessage id="global.vehicles" />,
        icon: <CarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seat-map',
        label: <IntlMessage id="global.seat_map" />,
        icon: <TableOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/addons',
        label: <IntlMessage id="global.addons" />,
        icon: <TableOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: '/app/customers',
    label: <IntlMessage id="global.customers" />,
    icon: <CustomerServiceOutlined />,
    permission: null,
    children: null,
  },

  {
    key: '/app/collaborators',
    label: <IntlMessage id="global.collaborators" />,
    icon: <UserOutlined />,
    permission: null,
    children: null,
  },
  {
    key: '/app/operators-route',
    label: <IntlMessage id="global.operators" />,
    icon: <BankOutlined />,
    permission: null,
    children: [
      {
        key: '/app/operators',
        label: <IntlMessage id="global.operators" />,
        icon: <BankOutlined />,
        permission: null,
        children: null,
      },
      // {
      //   key: '/app/op-payment-method',
      //   label: <IntlMessage id="global.op_payment_method" />,
      //   icon: <CreditCardOutlined />,
      //   permission: null,
      //   children: null,
      // },
    ],
  },

  {
    key: '/app/systems',
    label: <IntlMessage id="global.systems" />,
    icon: <ToolOutlined />,
    permission: null,
    children: [
      {
        key: '/app/users',
        label: <IntlMessage id="global.users" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/payment-method',
        label: <IntlMessage id="global.payment-method" />,
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/destinations',
        label: <IntlMessage id="global.destination" />,
        icon: <EnvironmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/sms-activity',
        label: <IntlMessage id="global.sms" />,
        icon: <MessageOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/recent-activity',
        label: <IntlMessage id="global.recentActivity" />,
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
    ],
  },

  {
    key: 'settings',
    label: <IntlMessage id="global.settings" />,
    icon: <SettingOutlined />,
    permission: null,
    children: [
      // {
      //   key: '/app/settings',
      //   label: <IntlMessage id="global.settings" />,
      //   icon: <FileOutlined />,
      //   permission: null,
      //   children: null,
      // },
      {
        key: '/app/user-Admin',
        label: <IntlMessage id="global.account" />,
        icon: <FileOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
];

export default menu;
